import { observer } from 'mobx-react';
import * as React from 'react';
import { T } from '../../../../Translations';

const HowThisWorks: React.FC = () => (
  <div>
    <h3 className="text-base font-semibold text-foreground">
      <T kind="How this works" />
    </h3>
    <ul className="mt-3 flex list-none flex-col gap-4 rounded-lg border-2 border-dashed border-border bg-secondary p-6">
      <li className="text-sm text-foreground">
        <span className="font-semibold">
          <T kind="Green means done." />
        </span>{' '}
        <T kind="When every required attribute matches, setup completes and you are back on the Single Sign-On page to assign domains." />
      </li>
      <li className="text-sm text-foreground">
        <span className="font-semibold">
          <T kind="Sent under a different claim name?" />
        </span>{' '}
        <T kind="Change the mapping here on the fly - no changes needed on your side - then re-test to confirm." />
      </li>
      <li className="text-sm text-foreground">
        <span className="font-semibold">
          <T kind="Required attribute missing?" />
        </span>{' '}
        <T kind="You will need to add the claim in your IdP and re-test before setup can finish." />
      </li>
      <li className="border-t border-border pt-4 text-sm text-muted-foreground">
        <T kind="The test signs you in through this connection without affecting anyone else - no domains route through it yet." />
      </li>
    </ul>
  </div>
);

export default observer(HowThisWorks);
